import { normalize } from 'normalizr';

import { form } from './schema/form';

export function normalizeFormData(data) {
  const { entities, result } = normalize(data, form);

  return { ...entities, form: entities.form[result] };
}
